import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import pages from "./content/pages.json";

export const App = () => {
  const location = useLocation();

  // On narrow screens the nav becomes a slide-in sidebar behind this toggle
  const [menuOpen, setMenuOpen] = useState(false);

  // Start each page at the top (and close the sidebar) when navigating
  useEffect(() => {
    window.scrollTo(0, 0);
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="site">
      <header className="site-header">
        <NavLink to="/" className="site-name">
          Colleen<span className="site-name-accent"> Dixon</span>
        </NavLink>
        <button
          className="nav-toggle"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
        {menuOpen && (
          <div className="nav-backdrop" onClick={() => setMenuOpen(false)} />
        )}
        <nav className={menuOpen ? "site-nav open" : "site-nav"}>
          <button
            className="nav-close"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          >
            ✕
          </button>
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/blog">Blog</NavLink>
          {pages.map((page) => (
            <NavLink key={page.slug} to={`/${page.slug}`}>{page.title}</NavLink>
          ))}
          <NavLink to="/play" className="nav-play">ThriftQuest</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>
      </header>

      <main className="site-main">
        <Outlet />
      </main>

      <footer className="site-footer">
        <p>© {new Date().getFullYear()} Colleen Dixon · Logo art by Kate Dixon</p>
        <p className="footer-links">
          <a href="https://www.linkedin.com/in/colleen-e-dixon">LinkedIn</a>
          <a href="https://github.com/colleendixon/projects">GitHub</a>
        </p>
      </footer>
    </div>
  );
};
